import { render, staticRenderFns } from "./figuresIncomeStatementDataView.vue?vue&type=template&id=9a40bb84&scoped=true"
import script from "./figuresIncomeStatementDataView.vue?vue&type=script&lang=js"
export * from "./figuresIncomeStatementDataView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a40bb84",
  null
  
)

export default component.exports